<template>
  <b-form-input
    :value="displayValue"
    v-bind="$attrs"
    v-on="inputListeners"
    @input="onInput"
    @blur="onBlur"
    @focus="onFocus"
  />
</template>

<script>
import { BFormInput } from 'bootstrap-vue'
import { formatNumeral } from 'cleave-zen'

export default {
  name: 'FormattedInput',
  components: {
    BFormInput,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'numeral', // 'numeral' for price/old_price/stock
      validator: value => ['numeral'].includes(value),
    },
  },
  data() {
    return {
      displayValue: '',
      rawValue: '',
    }
  },
  computed: {
    inputListeners() {
      // blur/input di-handle manual biar tidak double-fire ke parent
      // eslint-disable-next-line no-unused-vars
      const { input, blur, ...listeners } = this.$listeners
      return listeners
    },
    cleaveOptions() {
      return {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalMark: ',',
        delimiter: '.',
        numeralPositiveOnly: true,
        numeralDecimalScale: 0,
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue !== this.rawValue) {
          this.rawValue = newValue || ''
          this.updateDisplayValue()
        }
      },
    },
  },
  methods: {
    updateDisplayValue() {
      if (this.type === 'numeral') {
        this.displayValue = formatNumeral(this.rawValue.toString(), this.cleaveOptions)
      } else {
        this.displayValue = this.rawValue
      }
    },
    onInput(value) {
      // Get raw value first
      const rawValue = this.getRawValue(value)
      this.rawValue = rawValue

      // Format the value immediately for display
      if (this.type === 'numeral' && rawValue) {
        this.displayValue = formatNumeral(rawValue, this.cleaveOptions)
      } else {
        this.displayValue = rawValue
      }

      // Emit the raw value to parent
      this.$emit('input', rawValue)

      // Use nextTick to update the input value after Vue has processed the change
      this.$nextTick(() => {
        const input = this.$el
        if (input && this.displayValue !== input.value) {
          const cursorPosition = input.selectionStart
          const oldLength = input.value.length
          const newLength = this.displayValue.length

          // Update the input value
          input.value = this.displayValue

          // Restore cursor position, accounting for formatting changes
          const lengthDiff = newLength - oldLength
          const newCursorPosition = Math.max(0, cursorPosition + lengthDiff)
          input.setSelectionRange(newCursorPosition, newCursorPosition)
        }
      })
    },
    onBlur(event) {
      // Re-format on blur to ensure consistency
      this.updateDisplayValue()
      this.$emit('blur', event)
    },
    onFocus(event) {
      this.$emit('focus', event)
    },
    getRawValue(formattedValue) {
      if (!formattedValue) return ''

      // Remove thousands separator (.) and replace decimal separator (,) with .
      return formattedValue
        .replace(/\./g, '') // Remove thousands separators
        .replace(/,.*$/g, '') // Remove decimal separator and everything after it
        .replace(/\D/g, '') // Remove any non-digit characters
    },
  },
}
</script>
